export enum ProfileFeedFiltersType {
  MY_VIDEOS = "my-videos",
  FEATURED_IN = "featured-in",
  AWAITING_APPROVAL = "awaiting-approval",
  CREATOR_VIDEOS = "creator-videos",
}
